import CoachShell from '@/components/CoachShell';
import ChangePasswordCard from '@/components/ChangePasswordCard';
import { useI18n } from '@/lib/i18n';

export default function CoachSettings() {
  const { t } = useI18n();
  return (
    <CoachShell title={t('coach.settings')}>
      <div className="max-w-lg" data-testid="coach-settings">
        <p className="as-section mb-2.5">{t('pw.section')}</p>
        <ChangePasswordCard defaultOpen />
      </div>
    </CoachShell>
  );
}
